import React from "react";
import styled from "styled-components";
import Typography from "@material-ui/core/Typography";

import ImageSrc from "../images/woman-in-car-man-walking-city.png";

const Image = styled.img.attrs({ src: ImageSrc })`
  width: 100%;
  max-width: 520px;
  margin-top: 50px;
`;

const Wrapper = styled.div`
  padding: 20px;
  max-width: 750px;
  margin: 0 auto;
  text-align: center;
`;

const Title = styled(Typography).attrs({
  variant: "h2",
  color: "textSecondary",
})`
  && {
    margin: 40px;
  }
`;

const Subtitle = styled(Typography).attrs({
  variant: "body1",
  color: "textSecondary",
})`
  text-align: justify;
  text-justify: inter-word;
  && {
    margin-bottom: 50px;
  }
`;

const HowDoesItWork = ({ accountName, hideDecorativeImagery, ...props }) => {
  return (
    <Wrapper {...props}>
      {!hideDecorativeImagery && <Image />}
      <Title>How Does It Work?</Title>
      <Subtitle>
        <i>Simple:</i> You take the next 30 seconds to tell us about your
        vehicle. We evaluate the info you provide, take into consideration your
        vehicle condition and equipment, the local market, demand and
        availability for similar vehicles, then we do some number crunching, and
        voilà! You now have an accurate value estimation for your vehicle that
        you can use as you work on purchasing your next car, truck, or SUV from{" "}
        {accountName}.
      </Subtitle>
    </Wrapper>
  );
};

HowDoesItWork.defaultProps = {
  accountName: "dealer",
};

export default HowDoesItWork;
